import React from "react";
import {
    Box,
    Heading,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import LoginForm from "../components/LoginForm";

const Login: React.FC = () => {
    const bg = useColorModeValue("white", "gray.800");

    return (
        <Box
            minH="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            px={4}
            py={10}
            bgGradient="linear(to-br, gray.50, blue.50)"
        >
            <Box
                p={{ base: 6, md: 8 }}
                maxW="md"
                borderWidth={1}
                borderRadius="xl"
                boxShadow="lg"
                bg={bg}
                w="full"
            >
                <Text
                    color="blue.600"
                    fontWeight="bold"
                    textAlign="center"
                    mb={2}
                >
                    NewsReader
                </Text>
                <Heading mb={2} textAlign="center">
                    Welcome back
                </Heading>
                <Text color="gray.600" textAlign="center" mb={7}>
                    Sign in with the account provided by your team.
                </Text>

                <LoginForm />
            </Box>
        </Box>
    );
};

export default Login;
